import { useQueryUpdateCrm } from '@crm/hooks'
import { ExportType } from '@crm/types'
import { useLocales } from '@shared/locales'
import {
  downloadExtension,
  downloadFile,
  getTokenFromUrl,
  showApiErrors
} from '@shared/utils'
import { Button, Dropdown, notification } from 'antd'
import axios from 'axios'
import { Export } from 'iconsax-react'
import { useState } from 'react'

const API_URL = import.meta.env.VITE_APP_CRM_API as string
const API_ENDPOINT = '/leads/export'
const API_FULL_URL = `${API_URL}${API_ENDPOINT}`

export const ExportLeads = () => {
  const { t } = useLocales()
  const params = useQueryUpdateCrm()
  const [isPending, setIsPending] = useState(false)
  const sassAppToken = getTokenFromUrl()

  const exportLeadsFile = async (exportType: string) => {
    try {
      setIsPending(true)

      const token = localStorage.getItem('__access_token__')?.trim()

      const response = await axios.get(API_FULL_URL, {
        params: { ...params, export_type: exportType },
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${token}`,
          'Saas-App-Token': sassAppToken
        }
      })

      const extension =
        downloadExtension[exportType as keyof typeof downloadExtension] ||
        'xlsx'

      downloadFile(response.data, `leads_report.${extension}`)

      notification.success({
        message: t('success.success'),
        description: t('success.export_started')
      })
    } catch (error) {
      showApiErrors(error)
    } finally {
      setIsPending(false)
    }
  }

  return (
    <Dropdown
      trigger={['click']}
      menu={{
        items: Object.values(ExportType).map((value) => ({
          label: value.toUpperCase(),
          key: value
        })),
        onClick: ({ key }) => exportLeadsFile(key)
      }}
    >
      <Button loading={isPending} icon={<Export size={16} />}>
        {t('buttons.export')}
      </Button>
    </Dropdown>
  )
}
